import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const insertGradeAction = createAsyncThunk(`${companySliceName}/insertGrade`, async (data) => {
  const response = await server.post("/app/grade", data);
  return response.data;
});

export const updateGradeAction = createAsyncThunk(`${companySliceName}/updateGrade`, async (data) => {
  const response = await server.put("/app/grade", data);
  return response.data;
});

export const getGradesAction = createAsyncThunk(`${companySliceName}/getGrades`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/grade/views", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteGradeAction = createAsyncThunk(`${companySliceName}/deleteGrade`, async (uuid) => {
  const response = await server.delete(`/app/grade?uuid=${uuid}`);
  return response.data;
});
